export default "__VITE_ASSET__CBpMRCjr__"